import(/* webpackMode: "eager" */ "/app/apps/web/src/app/workspace/layout.tsx");
